import { connectHook } from 'app/common/components/connect-hook';
import { CodeBlock } from './code-block.js';
import { useCodeBlock } from './code-block-hook.js';

export default connectHook(CodeBlock, useCodeBlock);
